module.exports = __webpack_public_path__ + "static/media/MLEA.032faadf.pdf";